import { reverse } from "lodash";

const sortText = (field, reverse, primer, subfield = null) => {
    const key = primer
        ? function (x) {
              return primer(subfield ? x[field][subfield] : x[field]);
          }
        : function (x) {
              return subfield ? x[field][subfield] : x[field];
          };

    reverse = !reverse ? 1 : -1;
    return function (a, b) {
        a = key(a);
        b = key(b);
        if (a !== '-' && b !== '-') {
            return reverse * ((a > b) - (b > a));
        } else {
            return a === '-' ? 1 : -1;
        }
    };
};

const sortNumber = (field, reverse, subfield = null) => {
    const key = function (x) {
        return subfield ? x[field][subfield] : x[field];
    };
    return function (a, b) {
        return (a = key(a)), (b = key(b)), reverse ? b - a : a - b;
    };
};

const sortDate = (field, reverse) => {
    const key = function (x) {
        return x[field];
    };
    return function (a, b) {
        return (
            (a = new Date(key(a))),
            (b = new Date(key(b))),
            reverse ? b - a : a - b
        );
    };
};

const sortMoney = (field, reverse, subfield = null) => {
    const key = function (x) {
        return subfield ? x[field][subfield] : x[field];
    };
    return function (a, b) {
        let __a = key(a).replace("$", "");
        let __b = key(b).replace("$", "");

        __a = __a.split("");
        __b = __b.split("");

        __a = __a.map((char) => {
            if (char === ",") {
                return "";
            }
            return char;
        });

        __b = __b.map((char) => {
            if (char === ",") {
                return "";
            }
            return char;
        });

        __a = __a.join("");
        __b = __b.join("");

        return (a = __a), (b = __b), reverse ? b - a : a - b;
    };
};

export { sortText };
export { sortNumber };
export { sortDate };
export { sortMoney };
